import React, { useState, useEffect, useRef, useCallback } from 'react';
import MensajeError from '../UI/MensajeError.js';
import BotonBuscarChico from '../UI/botones/BotonBuscarChico.js';
import CampoComboPais from '../UI/campos/CampoComboPais.js';
import CampoEditableTexto from '../UI/campos/CampoEditableTexto.js';
import ComboSelector, { TipoClave } from '../UI/campos/ComboSelector.js';
import PopupCancelable from '../UI/PopupCancelable.js';
import { encontrarIdNumber, EsArrayVacio } from '../funciones/FuncionesArray.js';
import * as TipoEquipo from '../constantes/TipoEquipo.js';
import useGetListaURL from '../../hooks/useGetListaURL.js';
import * as Data from '../data/DataEquipos.js';
import styles from './PopupBuscarEquipo.module.css';
import { NombreEquipo } from '../funciones/FuncionesEquipo.js';

const ITEM_TIPO_VACIO = { codigo: null, descripcion: '(Todos)' };

const PopupBuscarEquipo = (props) => {
  const visible = props.visible;
  const textoIn = props.texto;
  const prefiltro = props.prefiltro || Data.PreFiltro.TODOS;
  const objetoFiltro = props.objetoFiltro || null;
  const [equipoFocus, setEquipoFocus] = useState(null);
  const [paisBuscar, setPaisBuscar] = useState(null);
  const [tipoBuscar, setTipoBuscar] = useState(ITEM_TIPO_VACIO);
  const [textoBuscar, setTextoBuscar] = useState(null);
  const [equipos, setEquipos] = useState(null);
  const [error, setError] = useState(null);
  const [listaTipos, setListaTipos] = useState([ITEM_TIPO_VACIO]);
  const buttonReferences = useRef([]);
  const { fetchData: fetchTipos, resetErroresGetLista } = useGetListaURL();

  useEffect(() => {
    resetErroresGetLista();
  }, [resetErroresGetLista]);

  useEffect(() => {
    fetchTipos('parametros/tipos_equipo', (data) => {
      setListaTipos([ITEM_TIPO_VACIO, ...(data || [])]);
    });
  }, [fetchTipos]);

  const busquedaHabilitada = (texto, pais, tipo) => {
    const tipoNoClub = tipo && tipo.codigo && tipo.codigo !== TipoEquipo.CLUB;
    return tipoNoClub || (texto && texto.length >= 3) || (pais && pais.id && pais.id !== '');
  };

  const buscarEquipos = useCallback(
    async (pais, tipo, texto) => {
      setError(null);
      if (busquedaHabilitada(texto, pais, tipo)) {
        try {
          const result = await Data.GetEquipos(prefiltro, objetoFiltro, pais, tipo, texto);
          if (result !== undefined && result !== null) {
            setEquipos(result);
          }
        } catch (e) {
          setError(e);
          setEquipos(null);
        }
      } else {
        setEquipos(null);
      }
    },
    [prefiltro, objetoFiltro]
  );

  // Inicializar con texto precargado al abrir
  useEffect(() => {
    const estaVacio = () => EsArrayVacio(equipos) || equipos === null;
    if (visible === true && estaVacio() && textoIn) {
      setTextoBuscar(textoIn);
      buscarEquipos(paisBuscar, tipoBuscar, textoIn);
    }
  }, [equipos, paisBuscar, tipoBuscar, visible, textoIn, buscarEquipos]);

  const vaciarForm = () => {
    setEquipos(null);
    setEquipoFocus(null);
    setTextoBuscar(null);
    setPaisBuscar(null);
    setTipoBuscar(ITEM_TIPO_VACIO);
    setError(null);
  };

  const onCampoChange = (nombre, valor) => {
    setTextoBuscar(valor);
    setEquipoFocus(null);
  };

  const onPaisElegido = (nombre, paisElegido) => {
    const pais = paisElegido && paisElegido.id ? paisElegido : null;
    setPaisBuscar(pais);
    buscarEquipos(pais, tipoBuscar, textoBuscar);
  };

  const onTipoElegido = (tipoElegido) => {
    // ITEM_TIPO_VACIO has codigo: null — treat as no filter
    const tipo = tipoElegido && tipoElegido.codigo ? tipoElegido : ITEM_TIPO_VACIO;
    setTipoBuscar(tipo);
    buscarEquipos(paisBuscar, tipo.codigo ? tipo : null, textoBuscar);
  };

  const onClickBuscar = () => {
    buscarEquipos(paisBuscar, tipoBuscar.codigo ? tipoBuscar : null, textoBuscar);
  };

  const equipoClickHandler = (event) => {
    event.preventDefault();
    const equipo = encontrarIdNumber(equipos, event.target.id);
    if (equipo) {
      props.onEquipoElegido(equipo);
      vaciarForm();
    }
  };

  const equipoFocusHandler = (equipo) => {
    setEquipoFocus(equipo);
  };

  const onAceptar = () => {
    if (equipoFocus) {
      props.onEquipoElegido(equipoFocus);
      vaciarForm();
    } else {
      alert('Seleccione un equipo');
    }
  };

  const onCancelar = () => {
    props.onCancelar();
    vaciarForm();
  };

  const mensajeListaVacia = () => {
    if (
      busquedaHabilitada(textoBuscar, paisBuscar, tipoBuscar) &&
      equipos &&
      equipos.length === 0
    ) {
      return 'No se encontraron equipos';
    }
    return 'Ingrese al menos tres caracteres del nombre, seleccione un país o seleccione un tipo de equipo que no sea Club para buscar';
  };

  let lista = [];
  if (equipos && busquedaHabilitada(textoBuscar, paisBuscar, tipoBuscar)) {
    for (const equipo of equipos) {
      lista = [...lista, equipo];
      if (lista.length === 10) {
        break;
      }
    }
  }

  return (
    <PopupCancelable
      visible={visible}
      texto=""
      height="22rem"
      width="30rem"
      mostrarEliminar={false}
      isGrabando={false}
      onAceptar={onAceptar}
      onCancelar={onCancelar}
    >
      <MensajeError errores={error} />
      <div className={`${styles.cuadroBusqueda}`}>
        <div className={`${styles.filaBusqueda}`}>
          <span className={`${styles.textoBusqueda}`}>Nombre:</span>
          <CampoEditableTexto
            nombre="buscar"
            valor={textoBuscar}
            largo={50}
            editar={true}
            estilo={`${styles.campoNombre}`}
            onChange={onCampoChange}
            onPressEnter={onClickBuscar}
          />
        </div>
        <div className={`${styles.filaBusqueda}`}>
          <span className={`${styles.textoBusqueda}`}>Tipo:</span>
          <ComboSelector
            lista={listaTipos}
            valorActual={tipoBuscar}
            campoClave={TipoClave.CODIGO}
            campoDescripcion="descripcion"
            isCargando={false}
            estilo={`${styles.campoTipo}`}
            onItemElegido={onTipoElegido}
          />
        </div>
        <div className={`${styles.filaBusqueda}`}>
          <span className={`${styles.textoBusqueda}`}>País:</span>
          <CampoComboPais
            nombre="pais"
            valor={paisBuscar}
            editar={true}
            incluirNulo={true}
            estilo={`${styles.campoPais}`}
            onChange={onPaisElegido}
          />
          <BotonBuscarChico estilo={`${styles.boton}`} onClick={onClickBuscar} />
        </div>
      </div>
      <div className={`${styles.listaEquipos}`}>
        {lista.length === 0 && (
          <span className={`${styles.listaVacia}`}>{mensajeListaVacia()}</span>
        )}
        <ul>
          {lista.map((equipo, index) => (
            <li key={equipo.id} id={equipo.id}>
              <button
                className={`${styles.itemEquipo}`}
                key={equipo.id}
                ref={(element) => (buttonReferences.current[index] = element)}
                id={equipo.id}
                onClick={equipoClickHandler}
                onFocus={() => equipoFocusHandler(equipo)}
              >
                {NombreEquipo(equipo)}
              </button>
            </li>
          ))}
        </ul>
      </div>
    </PopupCancelable>
  );
};

export default PopupBuscarEquipo;
